<script lang="ts">
	import { getRentalTemplateContext } from "./rental-template-context.svelte";
	import { PUBLIC_GOOGLE_MAPS_API_TOKEN } from "$app/env/public";
	import FooterContactForm from "./footer-contact-form.svelte";
	import { LazyLoad } from "#lib/web-ui/lazy-load/index.js";
	import { cloudinaryUrl } from "#lib/shared/cloudinary.js";

	const templateContext = getRentalTemplateContext()!;
</script>

<section id="contact" class="text-background bg-foreground relative py-16">
	<!-- Background image -->
	<div class="absolute inset-0 z-0">
		<img
			src={cloudinaryUrl("rental-template/community-aerial", { width: 1920, quality: 30 })}
			alt="Background"
			class="h-full w-full object-cover"
			width="1920"
			height="1080"
			loading="lazy"
		/>
		<!-- Overlay -->
		<div class="absolute inset-0 bg-[rgb(5,5,5)] opacity-90"></div>
	</div>

	<!-- Content -->
	<div class="relative z-10 container mx-auto px-4">
		<h2 class="mb-6 text-4xl font-medium">CONTACT US</h2>
		<hr class="border-primary mb-4 w-[100px] border-2" />

		<div class="grid grid-cols-1 gap-8 xl:grid-cols-2">
			<div>
				<p class="mb-6 text-lg">
					Call us now at {templateContext.contact.phone} or send a message using the form below
					and we'll get back to you.
				</p>

				<FooterContactForm />
			</div>

			<LazyLoad class="h-full min-h-[400px]">
				<iframe
					title="Our Office"
					width="100%"
					height="100%"
					frameborder="0"
					style="border:0"
					src={`https://www.google.com/maps/embed/v1/place?key=${PUBLIC_GOOGLE_MAPS_API_TOKEN}&q=${encodeURIComponent(
						`${templateContext.address.street}, ${templateContext.address.city}, ${templateContext.address.state} ${templateContext.address.zip}`
					)}`}
					allowfullscreen
				></iframe>
			</LazyLoad>
		</div>
	</div>
</section>
